<template>
  <div class="editSettle">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item>{{cueRowData.staffId}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名">{{cueRowData.staffName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="岗位">{{cueRowData.postId | filterPostId(infolist.postIdData)}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="最大折扣" prop="maxDiscount">
            <el-input v-model="form.maxDiscount" placeholder="请输入最大折扣" style="width:180px"></el-input>&nbsp;&nbsp;折
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin:20px 0;">
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="最大优惠金额" prop="maxPreferential">
            <el-input v-model="form.maxPreferential" placeholder="请输入最大优惠金额" style="width:180px"></el-input>&nbsp;&nbsp;元
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="seize"></div>
        </el-col>
        <el-col :span="17">
          <el-form-item label="最大抹零金额" prop="maxMaling">
            <el-input v-model="form.maxMaling" placeholder="请输入最大抹零金额" style="width:180px"></el-input>&nbsp;&nbsp;元
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btnOptions">
        <el-button class="darkBtn" @click="resetData">取消</el-button>
        <el-button class="redBtn" @click="onSubmit" :disabled="btnCostFlag">确定</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import infolist from "@/assets/js/info";
import { updateSettle } from "@/api";

export default {
  props: ["cueRowData", "openFlag"],
  data() {
    // 数字(一位小数)打折
    const isvalidateNumberPoint = (rule, value, callback) => {
      if (value > 0) {
        if (value != null && value != "") {
          if (/^\d*\.{0,1}\d{0,1}$/.test(value) == false) {
            callback(new Error("请输入数字，最多一位小数"));
          } else if (value > 9.9) {
            callback(new Error("只能输入0-9.9的数值"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback(new Error("只能输入0-9.9的数值"));
      }
    };
    const isvalidateMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (
          /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(
            value
          ) == false
        ) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > 999999.99) {
          callback(new Error("金额最大999999.99"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 抹零
    const isvalidateoddMoney = (rule, value, callback) => {
      if (value != null && value != "") {
        if (
          /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(
            value
          ) == false
        ) {
          callback(new Error("金额只能为正数或者两位小数"));
        } else if (value > 100) {
          callback(new Error("只能输入100以内数值"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      infolist,
      form: {
        maxDiscount: "",
        maxPreferential: "",
        maxMaling: ""
      },
      rules: {
        maxDiscount: [
          { required: true, message: "请输入最大折扣", trigger: "blur" },
          { type: "number", validator: isvalidateNumberPoint }
        ],
        maxPreferential: [
          { required: true, message: "请输入最大优惠金额", trigger: "blur" },
          { type: "number", validator: isvalidateMoney }
        ],
        maxMaling: [
          { required: true, message: "请输入最大抹零金额", trigger: "blur" },
          { type: "number", validator: isvalidateoddMoney }
        ]
      },
      btnCostFlag: this.openFlag
    };
  },
  created() {
    this.form = Object.assign({}, this.cueRowData);
  },
  watch: {
    cueRowData() {
      this.$refs.form.clearValidate();
      this.form = Object.assign({}, this.cueRowData);
    },
    openFlag() {
      this.btnCostFlag = this.openFlag;
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.btnCostFlag = true;
          let post = {
            staffId: this.cueRowData.staffId,
            maxDiscount: this.form.maxDiscount,
            maxPreferential: this.form.maxPreferential,
            maxMaling: this.form.maxMaling
          };
          updateSettle(post).then(res => {
            if (res.code == 1) {
              // 关闭当前进入列表页
              this.$emit("closeDialog", false);
            } else {
              this.btnCostFlag = false;
            }
            this.$message({
              type: res.code == 1 ? "success" : "error",
              message: res.msg
            });
          });
        } else {
          this.btnCostFlag = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {
      this.$confirm(
        "确定要取消本次编辑的信息吗？取消后本次编辑的内容不保存",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "继续编辑",
          cancelButtonText: "确定取消",
          type: "warning"
        }
      )
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.$refs.form.resetFields();
            this.$emit("closeDialog", false);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.editSettle {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .seize {
    height: 20px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
<style lang="less">
.editSettle {
  .lineH {
    .el-form-item__content {
      line-height: 25px;
      padding-top: 8px;
    }
  }
  .el-form-item__content {
    text-align: left;
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
  }
  .btnOptions {
    margin-top: 50px;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/editSettle.vue